import * as React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../services/redux/store";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import postsServices from "../../../services/api/service/postsService";
import { useNavigate } from "react-router-dom";
import { decrypt } from "../../../utils/crypto";
import { useDispatch } from "react-redux";
import {
  cleardisbursementButtonSlice,
  setdisbursementButtonValue,
} from "../../../services/redux/slices/disbursementButtonSlice";
import AwsOfferModal from "../AwsOfferModal";
import { useMediaQuery, useTheme } from "@mui/system";

const imageStyles = { width: "100%", height: "auto",  display: "block", margin: 0, padding: 0, borderTop: "1px solid #efecec" };

interface DisbursementFormTermDetailsProps {
  disbursementFormId: number;
}

const DisbursementFormThanksPage: React.FC<
  DisbursementFormTermDetailsProps
> = ({ disbursementFormId }) => {
  const dispatch = useDispatch();
  const emailId: any = useSelector(
    (state: RootState) => state?.auth?.userProfile?.email
  );
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [isAwsOfferModalOpen, setIsAwsOfferModalOpen] = React.useState<boolean>(false);
  

  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        {/* Thank You Image */}
        <Grid item xs={12}>
          <img
            src={require("../../../assets/images/thanks.png")}
            alt="thanks"
            style={{ width: "60px", height: "60px", marginBottom: "16px" }}
          />
        </Grid>

        {/* Thank You Text */}
        <Grid item xs={12}>
          <Typography
            sx={{
              color: "#4B465C",
              fontSize: "22px",
              fontWeight: "700",
              marginBottom: "8px",
            }}
          >
            Thank You! 😇
          </Typography>
          <Typography
            sx={{
              color: "#4B465C",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",
              marginBottom: "8px",
            }}
          >
            Your fund release request has been successfully submitted.
          </Typography>
          <Typography
            sx={{
              color: "#4B465C",
              fontSize: "15px",
              fontWeight: "400",
              lineHeight: "20px",
              marginBottom: "16px",
              width: "70%",
              textAlign: "center",
              margin: "0 auto", // Ensures the block is centered horizontally
            }}
          >
            {/* We sent an email to{" "}
            <strong>
              <span className="text-disable wordbreak">{decrypt(emailId)}</span>
            </strong>{" "}
            with your Disbursement confirmation and receipt. If the email hasn't
            arrived within two minutes, please check your spam folder to see if
            the email was routed there. */}
            All updates will be shared on your registered email ID and mobile number. If you don’t receive our email, please check your spam folder. You can also track the status anytime in the ‘Fund Release Request History’ section on this portal.
          </Typography>
        </Grid>

        {/* Time Placed */}
        {/* <Grid item xs={12}>
                    <Typography
                        sx={{
                            color: "#4B465C",
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "22px",
                            marginBottom: "16px",
                        }}
                    >
                        Time placed: 25/05/2020 13:35pm
                    </Typography>
                </Grid> */}

        {/* Back to Dashboard */}
        <Grid item xs={12}>
          <Typography
            sx={{
              color: "#00B3B5",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "22px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              localStorage.removeItem("activeFormStep");
              dispatch(cleardisbursementButtonSlice());
              dispatch(setdisbursementButtonValue(""));
            }}
          >
            Back to Dashboard &nbsp;{" "}
            <ArrowForwardIosIcon sx={{ fontSize: "15px" }} />
          </Typography>
        </Grid>
      </Grid>
      <Divider color="#c4c4c4" sx={{ marginBottom: {xs: "10px", sm: "25px"}, marginTop: {xs: "10px", sm: "25px"} }} />
      <Box sx={{ textAlign: "center", cursor: "pointer" }} 
        onClick={() => {
           setIsAwsOfferModalOpen(true)
        }}>
          {isXsOrSm ? (
            <img
              src={require("../../../assets/images/ThankYouPWA.png")}
              alt="thanks"
              style={imageStyles}
            />
          ) : (
            <img
              src={require("../../../assets/images/ThankYouWeb.jpeg")}
              alt="thanks"
              style={imageStyles}
            />
          )}
      </Box>
      {isAwsOfferModalOpen && <AwsOfferModal isAwsOfferModalOpen={isAwsOfferModalOpen} setIsAwsOfferModalOpen={setIsAwsOfferModalOpen} />}
    </>
  );
};

export default DisbursementFormThanksPage;
